import { getFeedbackRibbonForNudgeInfoBar } from './getFeedbackRibbonForNudgeInfoBar';
import { isFeatureEnabled } from 'owa-feature-flags';
import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import Message from 'owa-service/lib/contract/Message';
import { getNudgedRowKeyFromItemId, getStore as nudgeStore } from 'owa-mail-nudge-store';
import {
    InfoBarMessageRank,
    InfoBarMessageSource,
    InfoBarMessageViewState,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

/**
 * Create the nudged info bar if necessary
 * @param message the message
 * @param key the key of info bar message
 * @param itemViewModel
 * @return the nudged InfoBarMessageViewState
 */
export default function createNudgeFeedbackInfoBarViewState(
    message: Message,
    key: string,
    itemViewState: ItemViewState
): InfoBarMessageViewState {
    const rowKey = getNudgedRowKeyFromItemId(message.ItemId.Id);

    // Render nudge feedback info bar only if flight is enabled
    if (!isFeatureEnabled('tri-nudgeFeedback') || !rowKey) {
        return null;
    }

    const nudge = nudgeStore().nudgedRows.filter(nudgedRow => nudgedRow.rowKey === rowKey)[0];
    const messageBody = message.UniqueBody
        ? message.UniqueBody.Value
        : message.NormalizedBody
        ? message.NormalizedBody.Value
        : '';

    const emailDonationJson = JSON.stringify({
        messageBody: messageBody,
        internetMessageId: message.InternetMessageId,
        itemId: message.ItemId.Id,
    });

    // request for nudge feedback
    return <InfoBarMessageViewState>{
        key: key,
        source: InfoBarMessageSource.ReadingPane,
        rank: InfoBarMessageRank.Info,
        messageElement: getFeedbackRibbonForNudgeInfoBar(
            itemViewState,
            key,
            nudge.reason,
            emailDonationJson
        ),
    };
}
